<div class="page-container">
  <div class="page-header">
    <button mat-icon-button (click)="redirectToPriceTable()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div>
      <h2 class="page-title">Atualizar Tabela via Excel</h2>
      <p class="page-subtitle">Envie um arquivo Excel para atualizar a tabela de preços</p>
    </div>
  </div>
  <mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="loading">
    <div class="form-section">
      <div class="flex flex-col gap-5 w-full">
        <div class="flex flex-row">
          <mat-form-field subscriptSizing="dynamic" class="w-2on6">
            <mat-label>Montadora (OE)</mat-label>
            <input matInput type="text" [value]="automaker?.company?.tradeName" disabled />
          </mat-form-field>
        </div>
        <div class="flex flex-row">
          <mat-form-field class="w-2on6">
            <mat-label>Arquivo Excel</mat-label>
            <input
              matInput
              placeholder="Selecione um arquivo"
              value="{{ selectedFile ? selectedFile.item(0).name : null }}"
              (click)="fillFileInput.click()"
              autocomplete="off"
            />
            <input hidden (change)="selectFile($event)" #fillFileInput type="file" id="fillFileInput" autocomplete="off" />
            <mat-hint>Tipo de arquivo: .xlsx, .xls</mat-hint>
            <button mat-icon-button matSuffix color="primary" (click)="fillFileInput.click()">
              <mat-icon>open_in_browser</mat-icon>
            </button>
          </mat-form-field>
          <a mat-button color="primary" class="ml-4 w-100 flex flex-row items-center" style="margin-top: 10px">
            <mat-icon>cloud_download</mat-icon>
            <span (click)="downloadModelFile(automaker?.company?.id)">Download Arquivo Modelo</span>
          </a>
        </div>
      </div>
    </div>
    <div class="form-actions">
      <button mat-stroked-button color="primary" (click)="redirectToPriceTable()">
        <mat-icon>close</mat-icon><span>Cancelar</span>
      </button>
      <button mat-flat-button color="primary" class="mic-btn-icon-left" (click)="submitForm()">
        <mat-icon>check</mat-icon><span>Confirmar</span>
      </button>
    </div>
  </mic-spinner-overlay>
</div>